import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    accountName: {
        color: theme.palette.primary.main,
        fontSize: '14px',
        fontWeight: '600',
        marginLeft: '3px'
    },
    backButton: {
        color: 'primary',
        marginRight: theme.spacing(1)
    },
    loaderContainer: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2)
    },
    root: {
        fontFamily: 'Roboto',
        height: '100%',
        overflow: 'auto',
        padding: 0,
        width: '100%'
    },
    stepperButtons: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px'
    }
}));
